export const STORE_MARKER_COLOR = '#B1080F';
